import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchInvesterService } from 'api';



// Async thunk for fetching dashboard data
export const fetchinvesterServiceData = createAsyncThunk(
  'investerService',
  async (_, { rejectWithValue }) => {
    try {
      // Use the function from api.js
      const data = await fetchInvesterService();
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch dashboard data');
    }
  }
);

const investerServiceSlice = createSlice({
  name: 'investerService',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    resetError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchinvesterServiceData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchinvesterServiceData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchinvesterServiceData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetError } = investerServiceSlice.actions;
export default investerServiceSlice.reducer;
